import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const data = createReducer(
  {},
  {
    [ActionTypes.FETCH_RECOMMENDATIONS_SUCCESS]: (state, { payload }) => payload
  }
);

const setStatusForKey = (state, { type, payload }) =>
  Object.assign({}, state, { [payload.key]: type });

const status = createReducer(
  {},
  {
    [ActionTypes.FETCH_RECOMMENDATIONS_SUCCESS]: setStatusForKey,
    [ActionTypes.FETCH_RECOMMENDATIONS_ERROR]: setStatusForKey
  }
);

export default combineReducers({
  data,
  status
});
